// This fixes the floating point error that occurs when you multiply eg 0.1*0.2
export const roundDecimals = (value: number, decimalPlaces = 1) => Math.round(value * 10 ** decimalPlaces) / 10 ** decimalPlaces
